import { productColumns, productData } from '../../../Data/Ecommerce/ProductList';
import React, { Fragment } from 'react';
import DataTable from 'react-data-table-component';
import {Btn, H6} from '../../../AbstractElements'
import { Navigator } from '../../../Data/Table/Defaultdata';

const style = {
    width: 40,
    height: 40,
  };
  const style2 = { width: 60, fontSize: 14, padding: 4 };

const BillingTableData = (row) => {

    const productData = [
        {
          ind: 1,
          patient: "Patient Name",
          method: (
            <div>
              <H6>{'Straight Wire Fixed Appliance'}</H6>
              {/* <span>Interchargebla lens Digital Camera with APS-C-X Trans CMOS Sens</span> */}
            </div>
          ),
          amount:  <p className='font-primary'> &#x20B9; {"10"}</p>,
          status: <div className='font-success'>Open</div>,
          due: <div className='font-danger'>{'10000'}</div>,
          start_date: '2022/4/19',
          action: (
            <div>
              <span>
                {/* <Btn attrBtn={{ style: style2, color: 'danger', className: 'btn btn-xs', type: 'button' }}>Delete</Btn> */}
                <Navigator to={`${process.env.PUBLIC_URL}/checkout/:layout`} params={{ rowData: row, btn: "Pay" }}/>
              </span>
            </div>
          ),
        },
      ];
       const productColumns = [
        {
          name: '#',
          selector: (row) => row.ind,
          sortable: true,
          // center: true,
          // wrap: true,
          // minWidth: '100px',
          // maxWidth: '100px',
        },
        {
          name: 'Patient Name',
          selector: (row) => row.patient,
          sortable: true,
          center: true,
          wrap: true,
          // minWidth: '100px',
          // maxWidth: '100px',
        },
        {
          name: 'Treatment Details',
          selector: (row) => row.method,
          sortable: true,
          center: true,
          wrap: true,
          // minWidth: '100px',
          // maxWidth: '100px',
        },
        {
          name: 'Amount',
          selector: (row) => row.amount,
          sortable: true,
          center: true,
          // minWidth: '100px',
          // maxWidth: '150px',
        },
        {
          name: 'Treatment status',
          selector: (row) => row.status,
          sortable: true,
          // center: true,
          // minWidth: '120px',
          // maxWidth: '150px',
        },
        {
          name: 'Due Amount',
          selector: (row) => row.due,
          sortable: true,
          center: true,
          // minWidth: '120px',
          // maxWidth: '150px',
        },
        {
          name: 'Date',
          selector: (row) => row.start_date,
          sortable: true,
          center: true,
          // minWidth: '120px',
          // maxWidth: '150px',
        },
        {
          name: 'Action',
          selector: (row) => row.action,
          sortable: true,
          center: true,
          // minWidth: '160px',
          // maxWidth: '160px',
        },
      ];
  return (
    <Fragment>
      <div className='table-responsive product-table'>
        <DataTable noHeader pagination paginationServer columns={productColumns} data={productData} highlightOnHover={true} striped={true} responsive={true} />
      </div>
    </Fragment>
  );
};
export default BillingTableData;
